export default class DocumentBody {
  // static instance;

  constructor() {
    // this.notVideoSection = document.getElementById("not-video-section");
    // this.footer = document.getElementById("mantis-creative-footer");
    // document.body.scrollTo(0, 0);
    // if (DocumentBody.instance) {
    //   return DocumentBody.instance;
    // }
    // DocumentBody.instance = this;
  }

  enableScrollBar() {
    document.documentElement.style.overflow = "auto"; // firefox, chrome
    document.body.scroll = "yes"; // ie only

    // this.notVideoSection.style.display = "block";
    // this.footer.style.display = "block";
  }

  disableScrollBar() {
    document.documentElement.style.overflow = "hidden"; // firefox, chrome
    document.body.scroll = "no"; // ie only
    // document.body.scrollTo(0, 0);

    // this.notVideoSection.style.display = "none";
    // this.footer.style.display = "none";
  }
}
